// import React, { useEffect, useState } from 'react';
// import { Col, Container, Form, Nav, Row } from 'react-bootstrap';
// import './DeliveryLogin.css';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';


// const DeliveryLogin = () => {
//   const navigate = useNavigate()

//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [isValid, setIsValid] = useState(true)

//   const handleEmail = (e) => {
//     setEmail(e.target.value)
//     setIsValid(true)
//   }
//   const handlePassword = (e) => {
//     setPassword(e.target.value)
//     setIsValid(true)
//   }
  
//   //======================================================================================================

//   const loginFun = async (e) => {
//     e.preventDefault()
//     if (email === '' || password === '') {
//       setIsValid(false)
//       return
//     }

//     const logObj = {
//       email: email,
//       password: password,
//     }
//     console.log("lkkjsdh",logObj)

//     try {
//       const response = await axios.post('http://192.168.29.112:9082/api/userlogin/login',logObj)

//       console.log("++++++",response.data)
//       if (response.data.userdata && response.data.userdata.length > 0) {
//         const userData = response.data.userdata[0];
  
//         // Store user data in session storage
//         sessionStorage.setItem('userdata', JSON.stringify(userData));

//         navigate('/deliveryDashboard');
//       }
//       else if (response.data === 'NOTFOUND') {
        
//         toast.error('Invalid login details!!', {
//           position: "top-right",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
        
//       } 
//       // else if (response.data !== null) {
//       //   // Save user information in sessionStorage
//       //   console.log("data res-----",response.data)
//       //   sessionStorage.setItem('userdata', JSON.stringify(response.data));
//       //   // Navigate to the dashboard
//       //   navigate('/deliveryDashboard');
//       // } 
//        else {
//         toast.error('Invalid login details !!', {
//           position: "top-right",
//           autoClose: 2000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       }
//     } catch (error) {
//       console.error('Error:', error)
//       alert('Server Error')
//     }
//   }

//       //--------------- forgotpassword---------------------------//

//       const [forgetshow,setForgetshow]=useState()
//       const [forgetemail,setForgetemail]=useState()
//       const [phone,setPhone]=useState()
//       const handleforgetshow = () => {
//         setForgetshow(true)
//         // setLogshow(false)
//       };
//       const handleforgetClose = () => setForgetshow(false);
//       const handleEmailforChange = (e) => {
//         setForgetemail(e.target.value);
       
//       };

//       const handleforgetlog=(event)=>{
//         event.preventDefault();
//         const forgotdata={
//           email_id : forgetemail,
//           mobileno : phone
//         }
         
//       console.log("Email data",forgotdata);
//         axios.put('http://192.168.29.112:9082/api/employee/forgotPassword',forgotdata)
//         .then((res) => {
//           console.log("forgot Pass",res)
//             if (res.data === "SUCCESS") {
//               // alert("Your Password Has Been Sent On Email");
//               toast.success('Your Password Has Been Sent On Email', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//               });
//               setForgetshow(false)
//             } 
//             else if(res.data==="ERROR") {
//               // alert("Cheack Your Enter Emailid");
//               toast.error('Cheack Your Enter Email id', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//               });
//               setForgetshow(false)
//             }
//             // else if(res.data==="FAILED"){
//             //   alert("Failed To Send Email");
//             //   setForgetshow(false)
              
//             // }
//             else {
//               toast.error('Server Error', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//               });
              
//             }
//           })
//           .catch((err) => {
//               // alert("Failed To Send Email, try again");
//               toast.error('Failed To Send Email, try again', {
//                 position: "top-right",
//                 autoClose: 3000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//               });
//               setForgetshow(false)
//             });

// }

//   return (
//     <Container fluid>

//      <Row className='wrap1' style={{display:"flex",justifyContent:"center",alignItems:"center"}}>

//       <Col sm={12} md={12} className='   align-item-center '>
//         <Col style={{ display: 'flex', justifyContent: 'center' }}>
//           <Col sm={12} md={12} style={{ backgroundColor:"transparent" }}>

//               <div className='login-container'>     
//          <div className='login-form'>
//             <form>
//                 <div className='input'>
                    
//                     <h1 className='text-center pt-2' style={{color:"darksalmon"}}><i class="fa-solid fa-user fs-2" ></i>  Delivery Login</h1>
//                     <input id='input' type="Email" placeholder='Email Id' onChange={handleEmail} required/>

//                     <input id='input1' type="password" placeholder='Password' onChange={handlePassword} required/>

//                     {isValid ? null : (
//                   <Col
//                     style={{
//                       color: 'red',
//                       margin: '10px',
//                     }}
//                   >
//                     All fields are compulsory*
//                   </Col>
//                 )}
//                     <div className='login-button mb-2'>
//                     <button type="submit"  className='login-btn' onClick={loginFun} >LOGIN</button>
//                     </div>

//                     <div  className='pt-3' style={{display:"flex",justifyContent:"end"}}>
//                     <Nav.Link   style={{color:"white"}} onClick={() => setForgetshow(true)}><small className='forgot'>Forgot Password?</small></Nav.Link>
//                    </div>

//                     <div>
//                     <h6 className='text-center pt-5' style={{color:"lawngreen"}}>2023 DESIGN & DEVELOPED BY | TechnoAarv Solution</h6>
//                     </div>
//                 </div>
//             </form> 
//           </div>
//         </div>
            
//           </Col>
//         </Col>
//       </Col>
//       </Row>


//                       {/*//Forget PassWord Modal */}

//      <Modal show={forgetshow} onHide={handleforgetClose} animation={false}>
//         <Modal.Header className='p-0 px-3 py-1'  closeButton>
//           <Modal.Title style={{fontSize:"20px"}}>Fill Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form  onSubmit={handleforgetlog}>
//             <Row className="mb-3">
//               <Form.Group md="4" controlId="validationCustom01">
//                 <Form.Label>Enter Email</Form.Label>
//                 <Form.Control
//                   required
//                   type="Email"
//                   placeholder="Enter Email"
//                   onChange={handleEmailforChange}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   Enter Email Please
//                 </Form.Control.Feedback>
//               </Form.Group>
//               <Form.Group md="4" controlId="validationCustom01">
//                 <Form.Label className='mt-3'>Mobile No. </Form.Label>
//                 <Form.Control
//                     maxLength="10"
//                     inputMode="numeric"  
//                     title='Please enter 10 digit num.'
//                     type="tel"
//                     placeholder='Enter Mobile Num'
//                     id="mobileNumber"
//                     value={phone}
//                     onChange={(e) => {
//                       const numericValue = e.target.value.replace(/\D/g, "");
//                       setPhone(numericValue);
//                     }}
//                     required
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   Enter Mobile No
//                 </Form.Control.Feedback>
//               </Form.Group>
//             </Row>
//             <Button type="submit">Send Now</Button>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// export default DeliveryLogin;






import React, { useEffect, useState } from 'react';
import { Col, Container, Form, Nav, Row } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './DeliveryLogin.css'; 
import anime from 'animejs';
import logo from '../Assets/logonew.png'
import { DeliveryLoginAPI, EmployeeForgotApi } from '../Admin/API/Api';

const DeliveryLogin = () => {
  const handleFocus = (e) => {
    const current = anime.timeline({ autoplay: false });
    if (e.target.id === 'email') {
      current.add({
        targets: 'path',
        strokeDashoffset: { value: 0, duration: 700, easing: 'easeOutQuart' },
        strokeDasharray: { value: '240 1386', duration: 700, easing: 'easeOutQuart' }
      });
    } else if (e.target.id === 'password') {
      current.add({
        targets: 'path',
        strokeDashoffset: { value: -336, duration: 700, easing: 'easeOutQuart' },
        strokeDasharray: { value: '240 1386', duration: 700, easing: 'easeOutQuart' }
      });
    } else if (e.target.id === 'submit') {
      current.add({
        targets: 'path',
        strokeDashoffset: { value: -730, duration: 700, easing: 'easeOutQuart' },
        strokeDasharray: { value: '530 1386', duration: 700, easing: 'easeOutQuart' }
      });
    }
    current.play();
  };

  useEffect(() => {
    sessionStorage.clear()
  }, []);

  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isValid, setIsValid] = useState(true)

  const handleEmail = (e) => {
    setEmail(e.target.value)
    setIsValid(true)
  }
  const handlePassword = (e) => {
    setPassword(e.target.value);
    console.log("Password updated:", e.target.value);
    setIsValid(true);
  };
  
  //======================================================================================================

  const loginFun = async (e) => {
    e.preventDefault();
  
    if (email === '' || password === '') {
      setIsValid(false);
      console.log("Email or password is empty.");
      return;
    }
  
    const logObj = {
      email: email,
      password: password,
    };
  
    try {
      const response = await axios.post(DeliveryLoginAPI, logObj);
  
      if (response.data === 'NOTFOUND') {
        toast.error('Invalid login details!!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else if (response.data.userdata && response.data.userdata.length > 0) {
        const userData = response.data.userdata[0];
        sessionStorage.setItem('userdata', JSON.stringify(userData));
        navigate('/deliveryDashboard');
      } else {
        toast.error('Invalid login details !!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Server Error');
    }
  };

      //--------------- forgotpassword---------------------------//

      const [forgetshow,setForgetshow]=useState()
      const [forgetemail,setForgetemail]=useState()
      const [phone,setPhone]=useState()
      const handleforgetshow = () => {
        setForgetshow(true)
        // setLogshow(false)
      };
      const handleforgetClose = () => setForgetshow(false);
      const handleEmailforChange = (e) => {
        setForgetemail(e.target.value);
       
      };

      const handleforgetlog=(event)=>{
        event.preventDefault();
        const forgotdata={
          email_id : forgetemail,
          mobileno : phone
        }
         
      console.log("Email data",forgotdata);
        axios.put(EmployeeForgotApi,forgotdata)
        .then((res) => {
          console.log("forgot Pass",res)
            if (res.data === "SUCCESS") {
              // alert("Your Password Has Been Sent On Email");
              toast.success('Your Password Has Been Sent On Email', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setForgetshow(false)
            } 
            else if(res.data==="ERROR") {
              // alert("Cheack Your Enter Emailid");
              toast.error('Cheack Your Enter Email id', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setForgetshow(false)
            }
            // else if(res.data==="FAILED"){
            //   alert("Failed To Send Email");
            //   setForgetshow(false)
              
            // }
            else {
              toast.error('Server Error', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              
            }
          })
          .catch((err) => {
              // alert("Failed To Send Email, try again");
              toast.error('Failed To Send Email, try again', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setForgetshow(false)
            });

}

const textStyle = {
  fontFamily: "cursive",
  fontSize: "2rem",
  color: "rgb(47, 79, 79)",
  fontWeight: "normal",
  textDecoration: "underline",
  textAlign: "center",
  letterSpacing: "2px",
  lineHeight: "1.5",
  backgroundImage: "radial-gradient(circle, rgba(0, 0, 0, 0.2) 1px, transparent 1px)", // Dotted background gradient
  backgroundSize: "5px 5px",
  textShadow: "2px 2px 4px rgba(0,0,0,0.5)", // Adding a text shadow for the brushed effect
  // Add any additional styles here
};

  return (
    <div className="page">
      <div className="container1">
        <div className="left">
          <div style={{display:"flex",justifyContent:"center"}}><img src={logo} alt="Logo"  width={190} height={120} /></div>
            <h1  style={textStyle} className='pt-2'>Dairy Connect</h1>
        </div>
        <div className="right">
        
          <svg viewBox="0 0 320 300">
            <defs>
              <linearGradient
                id="linearGradient"
                x1="13"
                y1="193.49992"
                x2="307"
                y2="193.49992"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" style={{ stopColor: '#ff00ff' }} />
                <stop offset="1" style={{ stopColor: '#ff0000' }} />
              </linearGradient>
            </defs>
            <path
              d="m 40,120.00016 239.99984,-3.2e-4 c 0,0 24.99263,0.79932 25.00016,35.00016 0.008,34.20084 -25.00016,35 -25.00016,35 h -239.99984 c 0,-0.0205 -25,4.01348 -25,38.5 0,34.48652 25,38.5 25,38.5 h 215 c 0,0 20,-0.99604 20,-25 0,-24.00396 -20,-25 -20,-25 h -190 c 0,0 -20,1.71033 -20,25 0,24.00396 20,25 20,25 h 168.57143"
            />
          </svg>
         
          <div className="form1 ">
         
            <label htmlFor="email">Email</label>
            <input type="email" id="email" style={{borderBottom:"1px solid gray"}} onChange={handleEmail} onFocus={handleFocus} />
            <label htmlFor="password" >Password</label>
            <input type="password" id="password" style={{borderBottom:"1px solid gray"}} onChange={handlePassword} onFocus={handleFocus} />
             {/* <div  className='pt-3' style={{display:"flex",justifyContent:"end"}}>
            <Nav.Link   style={{color:"white"}} onClick={() => setForgetshow(true)}><small className='forgot'>Forgot Password?</small></Nav.Link>
          </div> */}
            <input type="submit" id="submit" value="Submit" className='text-center' onClick={loginFun} onFocus={handleFocus} />
            <label className='pt-4 text-center'>Developed By TechnoAarv Solution </label>
          </div>
         
          
        </div>
      </div>


         {/*//Forget PassWord Modal */}

     <Modal show={forgetshow} onHide={handleforgetClose} animation={false}>
        <Modal.Header className='p-0 px-3 py-1'  closeButton>
          <Modal.Title style={{fontSize:"20px"}}>Fill Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form  onSubmit={handleforgetlog}>
            <Row className="mb-3">
              <Form.Group md="4" controlId="validationCustom01">
                <Form.Label>Enter Email</Form.Label>
                <Form.Control
                  required
                  type="Email"
                  placeholder="Enter Email"
                  onChange={handleEmailforChange}
                />
                <Form.Control.Feedback type="invalid">
                  Enter Email Please
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group md="4" controlId="validationCustom01">
                <Form.Label className='mt-3'>Mobile No. </Form.Label>
                <Form.Control
                    maxLength="10"
                    inputMode="numeric"  
                    title='Please enter 10 digit num.'
                    type="tel"
                    placeholder='Enter Mobile Num'
                    id="mobileNumber"
                    value={phone}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/\D/g, "");
                      setPhone(numericValue);
                    }}
                    required
                />
                <Form.Control.Feedback type="invalid">
                  Enter Mobile No
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Button type="submit">Send Now</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DeliveryLogin;
